import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { fadeInAnimation } from '../../animations/fade-in.animation';
import { BlockPeriodClass } from '../../class/meal-plan/block-period.class';


@Component({
  selector: 'app-instruction-form',
  templateUrl: './instruction-form.component.html',
  styleUrls: ['./instruction-form.component.scss'],
  animations: [fadeInAnimation]
})
export class InstructionFormComponent implements OnInit, OnChanges, OnDestroy {

  @ViewChild('textInput') textInput: ElementRef;
  
  @Input() blockPeriod: BlockPeriodClass = new BlockPeriodClass(null, '', true); // GuidService removed

  @Output() add: EventEmitter<BlockPeriodClass> = new EventEmitter();
  @Output() changeBlockPeriod: EventEmitter<{ blockPeriod: BlockPeriodClass, action: 'add' | 'edit' | 'delete' | 'cancel' }> = new EventEmitter();


  constructor(
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.textInput?.nativeElement.focus();
    }, 200);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.blockPeriod) return;
    if (!this.blockPeriod._id) this.blockPeriod.setId(''); // GuidService removed, using empty string for now
  }


  onCancel(): void {
      this.changeBlockPeriod.emit({ blockPeriod: this.blockPeriod, action: 'cancel' });
  }


  async onEmitPutBlockPeriod(): Promise<void> {
    if (this.blockPeriod.editMode) {
      this.changeBlockPeriod.emit({ blockPeriod: this.blockPeriod, action: 'edit' });
      this.blockPeriod.setEditMode(false);
      return;
    }
    this.add.emit(this.blockPeriod);
  }


  ngOnDestroy(): void {
  }
}